import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-445b8370"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "stake-unbound-confirm-process"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("You have successfully"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("unbonded your assets")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "stake-unbound-confirm-process"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Something went wrong with your transaction", -1))
const _hoisted_5 = {
  key: 2,
  class: "stake-unbound-confirm-process"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Your transaction is"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("on the way")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Awaiting confirmation...", -1))

import DoneAnimation from "@/icons/animation/done.vue";
import ErrorAnimation from "@/icons/animation/error.vue";
import SpinnerAnimation from "@/icons/animation/spinner.vue";
import BaseButton from "@/components/base-button/index.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-unbond-confirm-process',
  props: {
  isDone: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const router = useRouter();



const detailsAction = () => {
  router.push({ name: "stake" });
};

const errorAction = () => {
  router.push({ name: "stake" });
};

return (_ctx: any,_cache: any) => {
  return (__props.isDone)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DoneAnimation),
        _hoisted_2,
        _createVNode(BaseButton, {
          title: "View details",
          action: detailsAction
        })
      ]))
    : (__props.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(ErrorAnimation),
          _hoisted_4,
          _createVNode(BaseButton, {
            title: "Try again",
            action: errorAction
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(SpinnerAnimation),
          _hoisted_6,
          _hoisted_7
        ]))
}
}

})